import { css } from '@emotion/react';

const utDark = css`
  --color-ut-primary: #3187ee;
  --color-ut-primary-up: #52a0ff;
  --color-ut-primary-down: #126bd9;

  --color-ut-primary-dim: rgba(49, 135, 238, 0.1);
  --color-ut-primary-dim-up: rgba(49, 135, 238, 0.2);
  --color-ut-primary-dim-down: rgba(49, 135, 238, 0.3);
  --color-ut-primary-dim-focus: rgba(49, 134, 238, 0.4);

  --color-ut-warning: #ffdf5a;
  --color-ut-warning-up: #ffd527;
  --color-ut-warning-down: #f8c800;

  --color-ut-warning-dim: rgba(255, 223, 90, 0.3);
  --color-ut-warning-dim-up: rgba(255, 223, 90, 0.5);
  --color-ut-warning-dim-down: rgba(255, 223, 90, 0.8);

  --color-ut-alert: #ed4040;
  --color-ut-alert-up: #ff5252;
  --color-ut-alert-down: #de3131;

  --color-ut-alert-dim: rgba(237, 64, 64, 0.15);
  --color-ut-alert-dim-up: rgba(237, 64, 64, 0.2);
  --color-ut-alert-dim-down: rgba(237, 64, 64, 0.3);
  --color-ut-alert-dim-focus: rgba(237, 64, 64, 0.2);

  --color-ut-error: #ff9113;
  --color-ut-error-up: #ffa238;
  --color-ut-error-down: #eb8709;

  --color-ut-success: #33b327;
  --color-ut-success-up: #42c936;
  --color-ut-success-down: #29a81d;

  --color-ut-success-dim: rgba(51, 179, 39, 0.1);
  --color-ut-success-dim-up: rgba(51, 179, 39, 0.2);
  --color-ut-success-dim-down: rgba(51, 179, 39, 0.3);
  --color-ut-success-dim-focus: rgba(51, 178, 39, 0.4);

  --color-ut-muted: #cfcfd5;
  --color-ut-muted-up: #e5e5e9;
  --color-ut-muted-down: #262626;

  --color-ut-input: rgba(199, 202, 206, 0.1);
  --color-ut-input-up: rgba(199, 202, 206, 0.13);
  --color-ut-input-down: rgba(199, 202, 206, 0.15);
  --color-ut-input-focus: rgba(199, 202, 206, 0.2);

  --color-ut-scream: #336fff;
  --color-ut-scream-up: #5795ff;
  --color-ut-scream-down: #0b3cff;

  --color-ut-scream-dim: rgba(49, 110, 255, 0.1);
  --color-ut-scream-dim-up: rgba(87, 137, 255, 0.2);
  --color-ut-scream-dim-down: rgba(28, 95, 255, 0.3);
  --color-ut-scream-dim-focus: rgba(28, 95, 255, 0.4);

  --color-ut-disabled: rgba(255, 255, 255, 0.04);

  --color-ut-border30: rgba(255, 255, 255, 0.3);
  --color-ut-border15: rgba(255, 255, 255, 0.15);
  --color-ut-border10: rgba(255, 255, 255, 0.1);
  --color-ut-border5: rgba(255, 255, 255, 0.05);

  --color-ut-shadow10: rgba(0, 0, 0, 0.1);

  --color-ut-bg-default: #1a1a1a;
  --color-ut-bg-default10: rgba(0, 0, 0, 0.1);
  --color-ut-bg-dim: #2c2c2c;
  --color-ut-bg-up: #333333;

  --color-ut-list-item-up: rgba(0, 0, 0, 0.05);
  --color-ut-list-item-down: rgba(0, 0, 0, 0.1);
  --color-ut-popup-shadow: rgba(0, 0, 0, 0.1);

  --color-ut-modal-overly: rgba(26, 26, 26, 0.5);
`;

const textDark = css`
  --color-text-default: #ffffff;
  --color-text-default-dim: rgba(255, 255, 255, 0.5);
  --color-text-disabled: rgba(255, 255, 255, 0.3);
  --color-text-inverse: #000000;
  --color-text-inverse-dim: rgba(0, 0, 0, 0.5);
  --color-text-primary: #52a0ff;
  --color-text-primary-inverse: #0b5acd;
  --color-text-success: #41d14d;
  --color-text-alert: #ff7878;
  --color-text-alert-dim: rgba(212, 25, 25, 0.2);
  --color-text-error: #ffa743;
  --color-text-warning: #ffa743;
  --color-text-button-default: #ffffff;
  --color-text-button-inverse: #000000;
`;

const graphDark = css`
  --color-graph-up: #5495d8;
  --color-graph-up-dim: rgba(80, 134, 200, 0.2);
  --color-graph-down: #e68282;
  --color-graph-down-dim: rgba(180, 86, 83, 0.15);
`;

const otherDark = css`
  --tooltip-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(0, 0, 0, 0.3);
  --preheader-fallback-bg: #444444;
  --preheader-bg: rgba(255, 255, 255, 0.05);
`;

export const darkTheme = css`
  [data-theme='dark'] {
    ${utDark};
    ${textDark};
    ${graphDark};
    ${otherDark};
  }
`;
